/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Feedback_LoadingInputs */



/**
* | output |
* | --- |
* | "Loading your feedback…" |
*
* @param {Practice_Feedback_LoadingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_feedback_loading = /** @type {((inputs?: Practice_Feedback_LoadingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Feedback_LoadingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je feedback wordt geladen…")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement de votre feedback…")
	return /** @type {LocalizedString} */ ("Loading your feedback…")
});